const scrollToElement = {
    methods: {
        scrollToElement() {     
            setTimeout(this.getScroll, 700);
        },
        getScroll() {
            let windowWidth = window.innerWidth;
            if(windowWidth <=768)
            {
               let element = document.getElementById("inicio");
                element.scrollIntoView();
            }
        }
    },
}

export default scrollToElement;
